import styled from 'styled-components';
import {
  Image,
} from 'semantic-ui-react';

const GoogleImage = styled(Image)`
 background-color: #FFFFFF !important;
 position: left;
 height: 18px;
 width: 18px;
 margin: 2px;
`;

const GoogleButtonIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  border-radius: 3px;
  height: auto;
  width: 38px;
  background-color: #FFFFFF;
`;

export {
  GoogleButtonIcon,
  GoogleImage,
};
